export enum WebSocketEventEnum {
    // general events
    Heartbeat = " Heartbeat",
    // client events
    ClientAuthentication = "Client_Authentication",
    ClientRevokeAuthentication = "Client_RevokeAuthentication",
    // member events
    MemberWalletUpdate = "Member_WalletUpdate",
}
